import ShiftStatus from "@pages/roster-create/components/shift-status.tsx";
import type * as type from "@vTypes";
import type { ShiftLookupMaps } from "@/utils/shift-util";
import type { ShiftCatalogShift } from "@/services/shift/shiftCatalog";
import { cn } from "@/utils/cn";

type PerShiftStatsRowProps = {
  readonly className?: string;
  readonly nurseSchedule: (string | null | { code: string | null })[];
  readonly scheduleIds?: (number | null)[];
  readonly shiftDefinitions: type.availableShifts[];
  readonly visibleShifts?: string[];
  readonly columnShiftIds?: string[];
  readonly columnShifts?: type.availableShifts[];
  readonly shiftLookupMaps: ShiftLookupMaps<ShiftCatalogShift>;
  readonly counts: { [key: string]: number | null } | null;
};

export default function PerShiftStatsRow({
  className,
  nurseSchedule,
  scheduleIds,
  shiftDefinitions,
  visibleShifts,
  columnShiftIds,
  columnShifts,
  shiftLookupMaps,
  counts,
}: PerShiftStatsRowProps) {
  return (
    <div className={cn("animate-in fade-in duration-200 ml-[10px] flex items-start pr-2", className)}>
      <ShiftStatus
        nurseSchedule={nurseSchedule}
        scheduleIds={scheduleIds}
        shiftDefinitions={shiftDefinitions}
        visibleShifts={visibleShifts}
        columnShiftIds={columnShiftIds}
        columnShifts={columnShifts}
        shiftLookupMaps={shiftLookupMaps}
        counts={counts}
      />
    </div>
  );
}
